var DatatableActionTypeEnum;
(function (DatatableActionTypeEnum) {
    DatatableActionTypeEnum["icon"] = "icon";
    DatatableActionTypeEnum["link"] = "link";
})(DatatableActionTypeEnum || (DatatableActionTypeEnum = {}));

var ErrorsEnum;
(function (ErrorsEnum) {
    ErrorsEnum["internal"] = "There was an Internal Server Error";
    ErrorsEnum["user_not_found"] = "It looks like the user you are trying to login with does not exist in our system";
})(ErrorsEnum || (ErrorsEnum = {}));

var FontAwesomeIcon;
(function (FontAwesomeIcon) {
    FontAwesomeIcon["download"] = "fa-download";
    FontAwesomeIcon["edit"] = "fa-edit";
    FontAwesomeIcon["fileCircleCheck"] = "fa-file-circle-check";
    FontAwesomeIcon["calendarLinesPen"] = "fa-calendar-lines-pen";
    FontAwesomeIcon["eye"] = "fa-eye";
    FontAwesomeIcon["contract"] = "fa-file-contract";
    FontAwesomeIcon["fileInvoice"] = "fa-file-invoice";
    FontAwesomeIcon["fileInvoiceDollar"] = "fa-file-invoice-dollar";
    FontAwesomeIcon["fileLines"] = "fa-file-lines";
    FontAwesomeIcon["downToBracket"] = "fa-down-to-bracket";
    FontAwesomeIcon["pen"] = "fa-pen";
    FontAwesomeIcon["listTimeline"] = "fa-list-timeline";
    FontAwesomeIcon["listCheck"] = "fa-list-check";
    FontAwesomeIcon["listTree"] = "fa-list-tree";
    FontAwesomeIcon["split"] = "fa-split";
    FontAwesomeIcon["trashCan"] = "fa-trash-can";
    FontAwesomeIcon["redo"] = " fa-arrow-rotate-right";
    FontAwesomeIcon["handHoldingDollar"] = "fa-hand-holding-dollar";
    FontAwesomeIcon["messageDollar"] = "fa-message-dollar";
    FontAwesomeIcon["messagesDollar"] = "fa-messages-dollar";
    FontAwesomeIcon["moneyCheckDollar"] = "fa-money-check-dollar";
    FontAwesomeIcon["settings"] = "fa-gear-complex";
    FontAwesomeIcon["circleInfo"] = "fa-circle-info";
})(FontAwesomeIcon || (FontAwesomeIcon = {}));

var FormErrorsEnum;
(function (FormErrorsEnum) {
    FormErrorsEnum["required"] = "This is a required field.";
    FormErrorsEnum["email"] = "Please enter a valid email address.";
    FormErrorsEnum["(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"] = "Please enter a valid URL (with http:// or https://).";
    FormErrorsEnum["^(([^<>()[]\\.,;:s@\"]+(.[^<>()[]\\.,;:s@\"]+)*)|(\".+\"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$"] = "Please enter a valid email address.";
    FormErrorsEnum["^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"] = "Please enter a valid email address.";
    FormErrorsEnum["000-0000"] = "Please enter a valid mobile number";
    FormErrorsEnum["000"] = "Please enter a valid area code";
    FormErrorsEnum["(000) 000-0000"] = "Please enter a valid mobile number";
    FormErrorsEnum["shouldEnterUrl"] = "Please enter an URL.";
    FormErrorsEnum["shouldEnterLink"] = "Please enter a link text.";
    FormErrorsEnum["passwordsNotMatching"] = "Passwords should be the same";
    FormErrorsEnum["office_nrds_id"] = "Invalid Office Id";
    FormErrorsEnum["member_nrds_id"] = "Invalid Member Id";
    FormErrorsEnum["association_nrds_id"] = "Invalid Association Id";
    FormErrorsEnum["invalidLicenseNumber"] = "Please enter a valid License Number";
    FormErrorsEnum["ccNumber"] = "Invalid Credit Card Number";
})(FormErrorsEnum || (FormErrorsEnum = {}));
const getMaskError = (requiredMask) => {
    switch (requiredMask) {
        case ('(000) 0000000'):
            return 'Please enter a valid phone number';
        default:
            return '';
    }
};
const getNumberError = (isMax, limitNumber) => {
    let message;
    if (limitNumber) {
        if (isMax) {
            message = `Please enter a number less than ${limitNumber}.`;
        }
        else {
            message = `Please enter a number higher than ${limitNumber}.`;
        }
    }
    else {
        if (isMax) {
            message = 'Please enter a lesser number.';
        }
        else {
            message = 'Please enter a higher number.';
        }
    }
    return message;
};
const getMaxLengthError = (maxLength) => {
    return `The max length for this field is ${maxLength}.`;
};

var PageLayoutSizeEnum;
(function (PageLayoutSizeEnum) {
    PageLayoutSizeEnum["lg"] = "100";
    PageLayoutSizeEnum["md"] = "80";
})(PageLayoutSizeEnum || (PageLayoutSizeEnum = {}));
var ModalMaxWidthSizeEnum;
(function (ModalMaxWidthSizeEnum) {
    ModalMaxWidthSizeEnum["lg"] = "600px";
    ModalMaxWidthSizeEnum["md"] = "480px";
    ModalMaxWidthSizeEnum["sm"] = "280px";
})(ModalMaxWidthSizeEnum || (ModalMaxWidthSizeEnum = {}));

const PROFILE_FORM_PERMISSIONS = {
    'active-primary': {
        email: { write: true },
        billing_cc: { write: true },
        first_name: { write: false },
        last_name: { write: false },
        middle_name: { write: true },
        preferred_name: { write: true },
        generation: { write: true },
        mobile: { write: true },
    },
    'inactive-primary': {
        email: { write: false },
        billing_cc: { write: false },
        first_name: { write: false },
        last_name: { write: false },
        middle_name: { write: false },
        preferred_name: { write: false },
        generation: { write: false },
        mobile: { write: false },
    },
    'secondary': {
        email: { write: true },
        billing_cc: { write: true },
        first_name: { write: false },
        last_name: { write: false },
        middle_name: { write: false },
        preferred_name: { write: false },
        generation: { write: false },
        mobile: { write: true },
    },
    'non-member': {
        email: { write: true },
        billing_cc: { write: true },
        first_name: { write: true },
        last_name: { write: true },
        middle_name: { write: true },
        preferred_name: { write: true },
        generation: { write: true },
        mobile: { write: true },
    }
};

var SuppressionType;
(function (SuppressionType) {
    SuppressionType["Email"] = "email";
    SuppressionType["Sms"] = "sms";
})(SuppressionType || (SuppressionType = {}));

var EventTypeColorEnum;
(function (EventTypeColorEnum) {
    EventTypeColorEnum["event"] = "#407C9E";
    EventTypeColorEnum["orientation"] = "#5D8E8D";
    EventTypeColorEnum["ethics"] = "#5D748D";
    EventTypeColorEnum["certification"] = "#9ABC76";
    EventTypeColorEnum["designation"] = "#E6514C";
    EventTypeColorEnum["ce_accredited"] = "#E3783F";
    EventTypeColorEnum["meeting"] = "#819EE9";
    EventTypeColorEnum["course_on_demand"] = "#A23ED0";
    EventTypeColorEnum["other"] = "#7A558B";
})(EventTypeColorEnum || (EventTypeColorEnum = {}));

var EventTypeLabelEnum;
(function (EventTypeLabelEnum) {
    EventTypeLabelEnum["event"] = "Events";
    EventTypeLabelEnum["orientation"] = "Orientation";
    EventTypeLabelEnum["ethics"] = "Ethics";
    EventTypeLabelEnum["certification"] = "Certifications";
    EventTypeLabelEnum["designation"] = "Designations";
    EventTypeLabelEnum["ce_accredited"] = "CE Accredited";
    EventTypeLabelEnum["meeting"] = "Meetings";
    EventTypeLabelEnum["course_on_demand"] = "Course on Demand";
    EventTypeLabelEnum["other"] = "Classes";
})(EventTypeLabelEnum || (EventTypeLabelEnum = {}));

var PaymentType;
(function (PaymentType) {
    PaymentType["EFT"] = "EFT";
    PaymentType["Check"] = "Check";
    PaymentType["Wire"] = "Wire";
    PaymentType["Checks"] = "Checks";
})(PaymentType || (PaymentType = {}));
var PreparedPaymentType;
(function (PreparedPaymentType) {
    PreparedPaymentType["An Invoice/s"] = "invoice";
    PreparedPaymentType["State Dues"] = "nip";
})(PreparedPaymentType || (PreparedPaymentType = {}));
var PreparedPaymentStatus;
(function (PreparedPaymentStatus) {
    PreparedPaymentStatus["Awaiting Payment"] = "awaiting_payment";
    PreparedPaymentStatus["Awaiting EFT"] = "awaiting_eft";
    PreparedPaymentStatus["Received"] = "received";
})(PreparedPaymentStatus || (PreparedPaymentStatus = {}));
var PreparedPaymentAddType;
(function (PreparedPaymentAddType) {
    PreparedPaymentAddType["Manual Entry"] = "single";
    PreparedPaymentAddType["Import"] = "multi";
})(PreparedPaymentAddType || (PreparedPaymentAddType = {}));
var PreparedPaymentLoadType;
(function (PreparedPaymentLoadType) {
    PreparedPaymentLoadType["By File"] = "byFile";
    PreparedPaymentLoadType["Copy/Paste Text"] = "copyPasteText";
})(PreparedPaymentLoadType || (PreparedPaymentLoadType = {}));
var PreparedPaymentFileType;
(function (PreparedPaymentFileType) {
    PreparedPaymentFileType["CSV"] = ".csv";
})(PreparedPaymentFileType || (PreparedPaymentFileType = {}));

var RPACType;
(function (RPACType) {
    RPACType["Corporate"] = "corporate";
    RPACType["Personal"] = "personal";
})(RPACType || (RPACType = {}));

var AssociationPaymentDateRange;
(function (AssociationPaymentDateRange) {
    AssociationPaymentDateRange["All"] = "all";
    AssociationPaymentDateRange["Today"] = "today";
    AssociationPaymentDateRange["Yesterday"] = "yesterday";
    AssociationPaymentDateRange["Last 7 days"] = "last_7_days";
    AssociationPaymentDateRange["Last 30 days"] = "last_30_days";
    AssociationPaymentDateRange["Custom"] = "custom";
})(AssociationPaymentDateRange || (AssociationPaymentDateRange = {}));
var AssociationPaymentType;
(function (AssociationPaymentType) {
    AssociationPaymentType["EC"] = "EC";
    AssociationPaymentType["XT"] = "XT";
    AssociationPaymentType["EFT"] = "EFT";
    AssociationPaymentType["IAD"] = "IAD";
    AssociationPaymentType["Chargedback"] = "Chargeback";
    AssociationPaymentType["Check"] = "Check";
    AssociationPaymentType["Wire"] = "Wire";
})(AssociationPaymentType || (AssociationPaymentType = {}));
var PaymentDetailsStatus;
(function (PaymentDetailsStatus) {
    PaymentDetailsStatus["All"] = "";
    PaymentDetailsStatus["Ok"] = "allocated";
    PaymentDetailsStatus["Underpayment"] = "underpayment";
    PaymentDetailsStatus["Overpayment"] = "overpayment";
    PaymentDetailsStatus["Unallocated"] = "unallocated";
    PaymentDetailsStatus["Pending"] = "pending";
    PaymentDetailsStatus["Failed"] = "failed";
    PaymentDetailsStatus["No Prepared Payment"] = "no_prepared_payment";
    PaymentDetailsStatus["Reallocated"] = "reallocated";
    PaymentDetailsStatus["Payment Returned"] = "payment_returned";
})(PaymentDetailsStatus || (PaymentDetailsStatus = {}));

var MemberStatusInputSelection;
(function (MemberStatusInputSelection) {
    MemberStatusInputSelection["By Member ID"] = "member_id";
    MemberStatusInputSelection["By License #"] = "license_number";
    MemberStatusInputSelection["By Office ID (Affiliates Only)"] = "office_id";
})(MemberStatusInputSelection || (MemberStatusInputSelection = {}));

var PackageTypeEnum;
(function (PackageTypeEnum) {
    PackageTypeEnum["Subscription"] = "subscription";
    PackageTypeEnum["Prepaid"] = "prepaid";
})(PackageTypeEnum || (PackageTypeEnum = {}));

var StateClassTypeLabelEnum;
(function (StateClassTypeLabelEnum) {
    StateClassTypeLabelEnum["broadcast"] = "Broadcast Class";
    StateClassTypeLabelEnum["subscription"] = "Subscription Class";
    StateClassTypeLabelEnum["self_managed"] = "Self Managed Class";
})(StateClassTypeLabelEnum || (StateClassTypeLabelEnum = {}));

var StateCourseClassTypeEnum;
(function (StateCourseClassTypeEnum) {
    StateCourseClassTypeEnum["Adhoc"] = "adhoc";
    StateCourseClassTypeEnum["Broadcast"] = "broadcast";
    StateCourseClassTypeEnum["Subscription"] = "subscription";
    StateCourseClassTypeEnum["Prepaid"] = "prepaid";
})(StateCourseClassTypeEnum || (StateCourseClassTypeEnum = {}));
var StateCourseClassStatusEnum;
(function (StateCourseClassStatusEnum) {
    StateCourseClassStatusEnum["Complete"] = "complete";
    StateCourseClassStatusEnum["Incomplete"] = "incomplete";
})(StateCourseClassStatusEnum || (StateCourseClassStatusEnum = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { AssociationPaymentDateRange, AssociationPaymentType, DatatableActionTypeEnum, ErrorsEnum, EventTypeColorEnum, EventTypeLabelEnum, FontAwesomeIcon, FormErrorsEnum, MemberStatusInputSelection, ModalMaxWidthSizeEnum, PROFILE_FORM_PERMISSIONS, PackageTypeEnum, PageLayoutSizeEnum, PaymentDetailsStatus, PaymentType, PreparedPaymentAddType, PreparedPaymentFileType, PreparedPaymentLoadType, PreparedPaymentStatus, PreparedPaymentType, RPACType, StateClassTypeLabelEnum, StateCourseClassStatusEnum, StateCourseClassTypeEnum, SuppressionType, getMaskError, getMaxLengthError, getNumberError };
